import React from 'react';
import PropTypes from 'prop-types';

const EyeIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20.571 12">
        <path d="M10.3 1.714a11.185 11.185 0 018.146 3.974c-1.2 1.575-4.04 4.6-8.146 4.6-3.789 0-6.8-3.031-8.124-4.635A11.293 11.293 0 0110.3 1.714zM10.3 0C3.811 0 0 5.615 0 5.615S4.144 12 10.3 12c6.628 0 10.273-6.385 10.273-6.385S16.893 0 10.3 0zm-.013 2.571A3.429 3.429 0 1013.714 6a3.428 3.428 0 00-3.428-3.429zm0 3.428a1.239 1.239 0 110-1.752A1.24 1.24 0 0110.282 6z" fill={fill} />
    </svg>
);

EyeIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

EyeIcon.defaultProps = {
    width: '20.571',
    height: '12',
    fill: '#4b254e'
};

export default EyeIcon;
